/* Getallen en data zoals de projectpagina ze toont (nl-NL). */

const EURO = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
const GETAL = new Intl.NumberFormat('nl-NL', { maximumFractionDigits: 0 });
const DATUM = new Intl.DateTimeFormat('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' });
const DATUM_KORT = new Intl.DateTimeFormat('nl-NL', { day: 'numeric', month: 'short' });

export const euro = (v: number | null | undefined) => (v === null || v === undefined ? '—' : EURO.format(v));
export const getal = (v: number | null | undefined) => (v === null || v === undefined ? '—' : GETAL.format(Math.round(v)));

/** '17 okt 2025'; binnen het lopende jaar '17 okt'. */
export function datum(iso: string | null | undefined, nu: Date = new Date()): string {
  if (!iso) return '—';
  const d = new Date(iso.length === 10 ? `${iso}T12:00:00` : iso);
  if (Number.isNaN(d.getTime())) return '—';
  return (d.getFullYear() === nu.getFullYear() ? DATUM_KORT : DATUM).format(d).replace('.', '');
}

export function tijd(iso: string | null | undefined, zone = 'Europe/Amsterdam'): string {
  if (!iso) return '—';
  return new Intl.DateTimeFormat('nl-NL', { hour: '2-digit', minute: '2-digit', timeZone: zone }).format(new Date(iso));
}

export function grootte(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined) return '—';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} kB`;
  return `${(bytes / 1024 / 1024).toLocaleString('nl-NL', { maximumFractionDigits: 1 })} MB`;
}

export function extensie(naam: string): string {
  const m = /\.([A-Za-z0-9]{1,10})$/.exec(naam);
  return m ? m[1]!.toLowerCase() : '';
}

export const IS_BEELD = new Set(['jpg', 'jpeg', 'png', 'heic', 'webp', 'gif', 'tif', 'tiff']);
